export const STORE_ADMIN_MERGE_HOTELS_HOTELS = 'adminMergeHotels';
export const ADMIN_MH_SET_OPTIONS = 'setOptions';
export const ADMIN_MH_FETCH_HOTELS = 'fetchHotels';
export const ADMIN_MH_FETCH_HOTELS_BY_DISTANCE = 'hotelsByDistance';
export const ADMIN_MH_FETCH_HOTELS_SAME_G_ADDRESS = 'hotelsSameGAddress';
export const ADMIN_MH_FETCH_HOTELS_SAME_PHONE_NUMBER = 'hotelsSamePhoneNumber';
export const ADMIN_MH_FETCH_BIGGEST_HOTELS = 'biggestHotels';
export const ADMIN_MH_FETCH_LOGS = 'fetchLogs';
export const ADMIN_MH_MERGE_HOTELS = 'mergeHotels';
export const ADMIN_MH_EXCLUDE_HOTELS = 'excludeHotels';
export const ADMIN_MH_BULK_MERGE_HOTELS = 'bulkMergeHotels';
export const ADMIN_MH_MERGE_WITH_HOTEL = 'mergeWithHotel';
export const ADMIN_MH_MERGE_BY_IDS = 'mergeByIds';
